import React, { Component } from 'react'
import { CollectionEditForm } from 'components'


export class TeamMembersForm extends Component{

  constructor(properties) {
    super(properties)

    this.attributes = [
      {name: 'name',        label: 'Name',  required: true},
      {name: 'title',       label: 'Title', required: true},
      {name: 'description', label: 'Description', required: true},
      {name: 'url',         label: 'URL',         required: true},
    ]
  }

  render = () =>
    <CollectionEditForm elements={ this.props.teamMembers } attributes={ this.attributes } onElementsChange={ this.props.onTeamMembersChange }/>
}

export default TeamMembersForm